const firebaseConfig = {
    apiKey: "AIzaSyDddg4JUmMaT9Xct4ElEk9KndVweua20O4",
    authDomain: "bookhall-99bc2.firebaseapp.com",
    projectId: "bookhall-99bc2",
    storageBucket: "bookhall-99bc2.appspot.com",
    messagingSenderId: "639941760239",
    appId: "1:639941760239:web:6a74c71d6d432654f8371a"
  };
  export default firebaseConfig;